import { defineComponent as _defineComponent } from 'vue'
import { onMounted, useRoute, ref, nextTick, computed } from '@nuxtjs/composition-api';
import PortfolioJobsInquirySectionEmpty from './PortfolioJobsInquirySectionEmpty/PortfolioJobsInquirySectionEmpty.vue';
import PortfolioJobsInquirySectionProfile from './PortfolioJobsInquirySectionProfile/PortfolioJobsInquirySectionProfile.vue';
import { JobsInquiryState } from '@/types/graphql';
import type { JobsInquiry, CurrentUser } from '@/types/graphql';

type PortfolioJobsInquirySectionProps = {
  inquiry: JobsInquiry;
  user: CurrentUser;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioJobsInquirySection',
  props: {
    inquiry: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
  inquiry: JobsInquiry;
  user: CurrentUser;
};



const route = useRoute();

const rootEl = ref<HTMLElement | null>(null);

const hasJobsProfile = computed(() => (props.inquiry ? props.inquiry?.state !== JobsInquiryState.Initialized : false));

onMounted(() => {
  if (route.value.hash === '#jobs-data') {
    nextTick(() => {
      rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
});

return { __sfc: true,props, route, rootEl, hasJobsProfile, PortfolioJobsInquirySectionEmpty, PortfolioJobsInquirySectionProfile }
}

})